<template>
  <div
    :class="[
      'draggable-tab-container',
      { 'draggable-tab-container-active': draggableTab.id === currentTab.id },
    ]"
  >
    <div class="draggable-tab-container-handle">
      <span
        v-if="isCurrentTab"
        :key="draggableTab.id + '_' + 'draggable_tab' + '_' + 'active'"
      >
        <ico name="icoDragHandle" color="#ffffff" />
      </span>
      <span v-else :key="draggableTab.id + '_' + 'draggable_tab'">
        <ico name="icoDragHandle" color="#d8dee2" />
      </span>
    </div>

    <div class="container-svg-notification">
      <div v-if="atInfo && atInfo.notificationEnabled" class="icon-true">
        <img
          src="../../assets/img/icon-at-symbol.svg"
          alt="at"
          width="14"
          height="14"
        />
      </div>
      <div class="tg-icon">
        <Telegram
          v-if="atInfo && atInfo.telegramEnabled"
          width="14"
          height="14"
          color="#828F99"
        />
      </div>
    </div>

    <button
      class="draggable-tab-inner-container"
      @click.stop="onClickDraggableTab(draggableTab)"
      :disabled="
        isRequesting ||
        (!authorities.includes('ROLE_SUBSCRIBED_USER') &&
          draggableTab.filterType === 'GENERAL')
      "
      @mouseenter="crudMenuVisible = true"
      @mouseleave="crudMenuVisible = false"
    >
      <div class="draggable-tab-inner-container-name">
        {{ draggableTab.name }}
      </div>
      <div class="draggable-tab-inner-container-crud-tab-counter">
        <div
          v-if="
            crudMenuVisible &&
            draggableTab.editable &&
            authorities.includes('ROLE_SUBSCRIBED_USER')
          "
          class="draggable-tab-inner-container-crud-tab-counter-crud-tab"
        >
          <button type="button" @click.stop="onClickEditDraggableTab">
            <PenIcon color="#79919C" />
          </button>
          <button type="button" @click.stop="onClickCopyDraggableTab">
            <img src="../../assets/img/tab-copy.svg" />
          </button>
          <button type="button" @click.stop="openConfirmModal">
            <ico name="icoDelete" size="20" color="#79919C" />
          </button>
        </div>
        <div
          class="draggable-tab-inner-container-crud-tab-counter-counter"
          v-if="draggableTab.newLots > 0"
        >
          <div
            class="draggable-tab-inner-container-crud-tab-counter-counter-number"
          >
            + {{ draggableTab.newLots }}
          </div>
        </div>
      </div>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  ConfirmModalProperties,
  PurchasesTableEditCustomFilterModalProperties,
} from "@/utils/modalsProperties";
import PurchasesTableCustomFilterModal from "@/components/purchasesTableCustomFilter/PurchasesTableCustomFilterModal";
import { mapFromDbToForm } from "@/utils/mapper";
import ConfirmModal from "@/components/common/ConfirmModal";
import { purchasesPath } from "@/router/purchases";
import { getNotificationEmail } from "../../application/requests/notificationsRequests";
import Telegram from "@/assets/icons/telegram.svg";
import PenIcon from "@/assets/icons/pen-icon.svg";

export default {
  name: "DraggableFilterTab",
  props: ["draggableTab"],
  components: {
    Telegram,
    PenIcon,
  },
  data() {
    return {
      crudMenuVisible: false,
      atInfo: {},
    };
  },
  computed: {
    ...mapGetters("filterTabs", [
      "filterTabByParam",
      "filterTabs",
      "currentTab",
    ]),
    ...mapGetters("profile", ["profileId"]),
    ...mapGetters("auth", ["authorities"]),
    ...mapGetters("purchases", ["isRequesting"]),
    isCurrentTab() {
      return this.draggableTab.id === this.currentTab.id;
    },
  },
  methods: {
    ...mapActions("filterTabs", [
      "getFilterTabs",
      "deleteFilterTab",
      "setCurrentTab",
    ]),
    onClickDraggableTab(draggableTab) {
      this.$emit("onChangeTab", draggableTab);
    },
    async onClickEditDraggableTab() {
      let filterData = mapFromDbToForm(this.draggableTab);
      try {
        if (filterData.notificationEnabled) {
          const response = await getNotificationEmail(this.draggableTab.id);

          if (response && response.data) {
            filterData = {
              ...filterData,
              daysWeek: response.data.notificationDays,
              timeNotification: response.data.notificationTimes,
              emailNotification: response.data.notificationEmails,
            };
          }
        }

        this.$modal.show(
          PurchasesTableCustomFilterModal,
          {
            formData: filterData,
            mode: "Edit",
            tabId: this.draggableTab.id,
          },
          PurchasesTableEditCustomFilterModalProperties,
        );
      } catch (error) {
        console.log(error);
      }
    },
    async onClickCopyDraggableTab() {
      try {
        const originalFormData = mapFromDbToForm(this.draggableTab);

        const copiedFormData = {
          ...originalFormData,
          name: `КОПИЯ_${originalFormData.name}`,
          id: null,
          createdAt: new Date().toISOString(),
          daysWeek: [],
        };

        if (originalFormData.notificationEnabled) {
          const response = await getNotificationEmail(this.draggableTab.id);
          if (response && response.data) {
            (copiedFormData.daysWeek = response.data.notificationDays),
              (copiedFormData.emailNotification =
                response.data.notificationEmails),
              (copiedFormData.timeNotification =
                response.data.notificationTimes);
          }
        }

        setTimeout(() => {
          this.$modal.show(
            PurchasesTableCustomFilterModal,
            {
              formData: { ...copiedFormData },
              mode: "Create",
            },
            PurchasesTableEditCustomFilterModalProperties,
          );
        }, 1000);
        this.$emit("closeMenu");
      } catch (error) {
        console.log(error);
        this.$toast.error("Не удалось создать копию фильтра");
      } finally {
        this.isCopying = false;
      }
    },

    async onClickRemoveDraggableTab() {
      try {
        await this.deleteFilterTab(this.draggableTab.id);
        await this.getFilterTabs(this.profileId);

        let tab = this.filterTabByParam("id", this.currentTab.id);

        if (!tab) {
          tab = this.filterTabByParam("filterType", "ALL");
          this.$router.push(`${purchasesPath}/${tab.id}`);
          this.setCurrentTab(tab);
          this.$emit("closeDraggableTabFiltersMenu");
          return;
        }

        this.$emit("closeDraggableTabFiltersMenu");
      } catch (e) {
        this.$toast.error(e.message);
      }
    },
    openConfirmModal() {
      this.$modal.show(
        ConfirmModal,
        {
          text: `Вы действительно хотите удалить фильтр <strong>${this.draggableTab.name}</strong>?`,
          callback: this.onClickRemoveDraggableTab,
        },
        ConfirmModalProperties,
      );
    },
    initAtInfo() {
      if (this.draggableTab) {
        this.atInfo = mapFromDbToForm(this.draggableTab);
      }
    },
  },

  created() {
    this.initAtInfo();
  },
};
</script>

<style scoped lang="less">
@import "../../assets/less/variables.less";

.draggable-tab-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  height: 40px;
  background-color: transparent;
  font-weight: 200;
  cursor: pointer;
  &:hover:not(&-active) {
    background-color: #f6f7f8;
  }

  &&-active {
    background-color: #cfd8dd;
    font-weight: 500;
    .draggable-tab-inner-container {
      &-name {
        font-weight: 500;
      }
    }
  }

  &-handle {
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      width: 24px;
      height: 24px;
    }
  }

  .container-svg-notification {
    display: flex;
    gap: 4px;
    align-items: center;
    height: 14px;
    min-width: 32px;
    margin-right: 4px;
    &__tg-icon {
      max-width: 14px;
      min-width: 14px;
      max-height: 14px;
    }
  }
}

.draggable-tab-inner-container {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 4px;
  width: 100%;

  &-crud-tab-counter {
    display: flex;
    align-items: center;

    &-crud-tab {
      display: flex;
    }

    &-counter {
      display: flex;
      align-items: center;
      border-radius: 12px;
      margin-left: 5px;
      padding: 0 2px;
      height: 24px;
      max-width: 50px;
      font-size: 12px;
      color: @text-color-light;
      background-color: @bg-color-light;

      &-number {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  &-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
